import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link } from "react-router-dom";
import "./Scholarships.css";
import api from "../../utils/api";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SchoolIcon from "@mui/icons-material/School";

export const Scholarship = () => {
  const [scholarships, setScholarships] = useState([]);
  useEffect(() => {
    api
      .get("/scholarships")
      .then((res) => {
        console.log("scholarships>", res.data);
        setScholarships(res.data);
        // let array = res.data;
        // let temp = res.data;
        // var n = array.length;
        // var j = 0;
        // for (var i = 0; i < 40; i++) {
        //   if (j === n) {
        //     i = 0;
        //   }
        //   array.push(temp[j]);
        //   j++;
        // }
        // setScholarships(array);
      })
      .catch((err) => console.log(err));
  }, []);
  const [itemsPerPage, setItemsPerPage] = useState(9);
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(scholarships.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(scholarships.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, scholarships]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % scholarships.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  return (
    <Box>
      {/* <Header />
      <Menunav /> */}
      <Box className="row">
        {/* <Box className="col-md-2 col-0">
          <Sidebar />
        </Box> */}
        <Box className="col-md-12 col-12">
          {/* <Box className="row mt-3">
            <Box className="col-6">
              <h3>Scholarships:</h3>
            </Box>
            <Box className="col-6">
              <Link to="/scholarship/post" className="btn-link">
                Post a Scholarship
              </Link>
            </Box>
          </Box> */}
          <Box className="container">
            {/* {scholarships.length > 0 ? (
              scholarships.map((sch) =>(<h1>M</h1>) )
            ) : (
              <h5>No Scholarship Added</h5>
            )} */}
            <Items
              // currentItems={currentItems}
              currentItems={scholarships}
              setCurrentItems={setCurrentItems}
            />

            {/* <ReactPaginate
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="< previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            /> */}
            {/* <Link to="/scholarship/userscholarship">
              <button className=" btn">User Scholarships</button>
            </Link> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
function Items({ currentItems, setCurrentItems }) {
  return (
    <>
      <Box className="container feeds">
        {currentItems &&
          currentItems
            .sort(function (a, b) {
              return new Date(b.updatedAt) - new Date(a.updatedAt);
            })
            .map((sch) => <Sch sch={sch} />)}
      </Box>
    </>
  );
}

export const Sch = ({ sch }) => {
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    console.log("schoalrship for error correction", sch);
    sch?.userId &&
      api
        .get(`/user/getUserdataById/` + sch?.userId)
        .then((res) => {
          console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [sch]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const navigate = useNavigate();
  const deleteScholarship = (s) => {
    api
      .delete(`/scholarships/${s?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your scholarship for violating terms and conditions.`,
            forAll: false,
            receiverId: s?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };

  return (
    <Card sx={{ width: "100%", marginBottom: "30px" }}>
      <CardHeader
        onClick={() => navigate(`/user-profile/${sch?.userId}`)}
        className="title__link"
        avatar={
          <Stack direction="column">
            {uploader?.profile ? (
              <Avatar
                src={uploader?.profile}
                alt={uploader?.name?.at(0)?.toUpperCase()}
              />
            ) : (
              <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                {uploader?.name?.at(0)?.toUpperCase()}
              </Avatar>
            )}
          </Stack>
        }
        // action={
        //   <IconButton aria-label="settings">
        //     <MoreVertIcon />
        //   </IconButton>
        // }
        title={uploader?.name?.toUpperCase()}
        subheader={new Date(sch?.createdAt).toDateString()}
      />
      {/* {hostel?.hostelImage && (
                <CardMedia
                  component="img"
                  height="50"
                  width="50"
                  image={hostel?.hostelImage}
                  alt="Paella dish"
                />
              )} */}
      <CardContent sx={{ marginTop: "-20px" }}>
        <Box
          sx={{
            boxShadow: "none",
            padding: "20px 0",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              textTransform: "whitesmoke",
              fontWeight: "600",
              cursor: "pointer",
            }}
            className="title__link"
            onClick={() => navigate(`/scholarship-details/${sch?._id}`)}
          >
            {sch?.title}
          </Typography>
          <Grid container gap={1} sx={{ marginTop: "20px" }}>
            <Grid item xs={12} lg={12}>
              <Grid container gap={6}>
                <Grid
                  item
                  xs={10}
                  lg={5}
                  sx={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                    marginTop: { xs: "20px", lg: "0" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {" "}
                    <Typography
                      variant="body2"
                      sx={{
                        width: "150px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <SchoolIcon sx={{ color: "gray", marginRight: "5px" }} />
                      Schoalrship For
                    </Typography>
                    <Typography variant="body2">
                      {sch?.scholarshipFor}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "150px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <LocationOnIcon
                        sx={{ color: "gray", marginRight: "5px" }}
                      />
                      Country
                    </Typography>
                    <Typography variant="body2">{sch?.country} </Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "150px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <CalendarMonthIcon
                        sx={{ color: "gray", marginRight: "5px" }}
                      />
                      Duration
                    </Typography>
                    <Typography variant="body2">{sch?.duration}</Typography>
                  </Box>

                  {/* <Box sx={{ display: "flex" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "120px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <CallIcon sx={{ color: "gray", marginRight: "5px" }} />
                      Contact
                    </Typography>
                    <Typography variant="body2">
                      {inte?.generalData?.contact}
                    </Typography>
                  </Box> */}
                </Grid>
                <Grid
                  item
                  xs={10}
                  lg={5}
                  sx={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ display: "flex" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "120px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <CreditCardIcon
                        sx={{ color: "gray", marginRight: "5px" }}
                      />
                      Amount
                    </Typography>
                    <Typography variant="body2">{sch?.amount}</Typography>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "120px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <TimelapseIcon
                        sx={{ color: "gray", marginRight: "5px" }}
                      />
                      Deadline
                    </Typography>
                    <Typography variant="body2">{sch?.deadline} </Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "120px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <TimelapseIcon
                        sx={{ color: "gray", marginRight: "5px" }}
                      />
                      Type
                    </Typography>
                    <Typography variant="body2">
                      {sch?.scholarshipType}{" "}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              {sch?.description && (
                <Box sx={{ marginTop: "20px" }}>
                  <Typography
                    variant="body2"
                    className="title__link ellipsis__two__lines"
                    onClick={() => navigate(`/scholarship-details/${sch?._id}`)}
                  >
                    {sch?.description}
                  </Typography>
                </Box>
              )}
              {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  style={{
                    marginLeft: "auto",
                    marginTop: "10px",
                    textDecoration: "underline",
                  }}
                  className=""
                  onClick={() => navigate(`/scholarship-details/${sch?._id}`)}
                >
                  details
                </button>
              </Box> */}

              {currentUser?.isAdmin && (
                <button
                  className="asc__submit__form__button"
                  onClick={() => deleteScholarship(sch)}
                >
                  Delete Scholarship
                </button>
              )}
            </Grid>
          </Grid>
        </Box>
      </CardContent>

      {/* <CardContent>
        <Typography
          sx={{
            fontSize: "1.5rem",
            marginBottom: "10px",
            fontWeight: "500",
            textTransform: "capitalize",
          }}
          color="fontPrimaryColor.main"
          className="question__title"
          // onClick={() => navigate(`/answers/${question._id}`)}
        >
          {sch?.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {sch?.description}
        </Typography>
        {sch?.schImage && (
          <img
            style={{
              margin: "20px 0",
              marginLeft: "50%",
              transform: "translateX(-50%)",
            }}
            height="auto"
            width="60%"
            src={sch?.schImage}
            alt="Paella dish"
          />
        )}
        <Box className="language mt-4 bg-white">
          <Box className="tags bg-white">
            {sch?.tags?.map((t) => (
              <Typography className="tag-span">{t}</Typography>
            ))}
          </Box>
        </Box>
       
        <Box
          className="country mt-2 mb-1"
          sx={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Country
          </Typography>
          <Typography variant="body2">{sch?.country} </Typography>
        </Box>
        <Box
          className="duration mb-1"
          sx={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Duration
          </Typography>
          <Typography>{sch?.duration} </Typography>
        </Box>
        <Box
          className="duration mb-1"
          sx={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Amount
          </Typography>
          <Typography>{sch?.amount} PKR</Typography>
        </Box>
        <Box
          className="amount  mb-1"
          sx={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Deadline
          </Typography>
          <Typography>{sch?.deadline ? sch?.deadline : "null"}</Typography>
        </Box>
        <Box
          className="amount mb-4 mb-1"
          sx={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Scholarship For
          </Typography>
          <Typography>
            {sch?.scholarshipFor ? sch?.scholarshipFor : "null"}
          </Typography>
        </Box>
        <Box
          className="visitlink"
          sx={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Visit link
          </Typography>
          <Typography
            sx={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {sch?.url ? sch?.url : "null"}
          </Typography>
        </Box>
        {currentUser?.isAdmin && (
          <button
            className=" asc__submit__form__button"
            onClick={() => deleteScholarship(sch)}
          >
            Delete Scholarship
          </button>
        )}
      </CardContent> */}
    </Card>
  );
};
